export enum MenuItemEnum {
  // Forecast
  // Forecast = 17,
  // ForecastValidationLog = 18,
  // ForecastDeepDive = 19,
  // ForecastOverview = 22,
  // ForecastAccuracy = 28,
  // ForecastUploadRealignment = 33,

  // Forecast New Menu Items
  ForecastNew = 1063,
  ForecastOverviewNew = 1064,
  ForecastDeepDiveNew = 1065,
  ForecastValidationLogNew = 1066,
  ForecastTopdownAdjustmentNew = 1067,
  ForecastDetailedPostingsNew = 1069,
  ForecastAccuracyNew = 1068,
  ForecastAccuracyV2 = 2098,

  ForecastPivotNew = 1071,
  ForecastPivotNewOption = 1073,

  ForecastActivitySubMenu = 2078,
  ForecastActivity = 1074,
  ForecastActivityList = 1075,
  ForecastActivityResult = 2079,


  // Stock Controlling
  StockControlling = 4,
  StockControllingDeepDive = 5,
  StockControllingHeatmap = 6,
  StockControllingOverview = 7,
  StockControllingIssueDevelopment = 15,

  // ESO
  EsoContainer = 36,
  EsoOverview = 38,
  EsoDecisionTree = 1036,
  EsoNetworkDeepDive = 1054,
  EsoSimulateMulti = 1055,
  EsoDeepDive = 2085,
  EsoDetailedPostings = 2086,
  EsoSupplyForecast = 2087,
  EsoStockProjection = 2100,
	EsoNetworkDeepDiveMap = 2097,

  Network = 2125,

  // Settings
  Settings = 10,
  RoleMenuPermission = 3,
  SelectionOptions = 9,
  GeneralSettings = 14,
  ForecastAdjustment = 20,
  ManageRole = 21,
  Advanced = 1053,
  RoleContentPermission = 13,
  ForecastHistory = 2095,

  // Accounts
  User = 2,
  UserParent = 2090,

  AddUser = 24,

  // Task
  Task = 12,
  AddTask = 23,
  TaskList = 1037,

  // Help
  Help = 32,
  HelpList = 16,
  HelpCategory = 29,
  HelpPages = 30,
//HelpTest
HelpTest=2127,
  //ManualInput
  ManualInput = 1046,
  ManualDataUpdate = 1051,


  //Statistical Forecast
  StatisticalForecasting = 1057,
  StatisticalForecastingOverview = 1061,
  StatisticalForecastingDeepDive = 1062,

  // General
  General = 2075,
  Feed = 2088,
  Map = 2096,
  ProjectDeepDive = 2076,
  ProjectTemplates = 2091,
  Home = 2084,
  About = 2099,
	DynamicOverview = 2108,

  //MRP
  MRP = 2077,
  Replenishment = 2074,
  MrpDeepDive = 2080,
	OrderOptimizer = 2107,

  // Capacity
  Capacity = 2081,
  CapacityOverview = 2082,
  CapacityDeepDive = 2083,
  MailConfiguration = 2092,


  ManualDataInputUpdate = 2093,
  ForecastDeepDiveMulti = 2101,

  //Scenario Comparison
  ScenarioComparison = 2110,
  ScenarioComparisonMain = 2111,
  ScenarioAdjustment = 2114
}
